import { identify, init } from '@dash0/sdk-web';

import appConfig from '@/config';

export const initDash0 = () => {
  if (appConfig.dash0) {
    init({
      ...appConfig.dash0,
      serviceVersion: APP_VERSION,
    });
  }
};

export const identifyDash0User = ({ userId, email, fullName }) => {
  if (appConfig.dash0 && userId) {
    identify(String(userId), { email, fullName });
  }
};
